
const frontDeskFormMap = {
    TypeA : {
        weightage:10,
        formTitle : "ASIC Search",
        formDescription : ["Pty Ltd name Search of the nominated Corporation (ASIC)","Registration of Business name (ASIC)"],
        fields : {
            companyThumbnail : { // 1
                label : "Upload Company Thumbnail",
                type : "file",
                link : "https://asicconnect.asic.gov.au",
            },
            businessExpiry : { // 4
                label : "Business Expiry",
                type : "date",
                link : "https://asicconnect.asic.gov.au",
            }
        }
    },
    TypeB : {
        weightage:10,
        formTitle : "Corporation Search",
        formDescription : ["Corporation License search Fair Trading","Corporation License registered office address"],
        fields : {
            corporationLicenseExpiry : { // 2
                label : "Corporation License Expiry",
                type : "date"
            },
            corporationLicenseCompliance : { // 3
                label : "Corporation License Compliance",
                type : "checkbox"
            },
        }
    },
    TypeC : {
        weightage:5,
        formTitle : "Registered Office Display",
        formDescription : ["Correct details are displayed at registered office."],
        fields : {
            registeredOfficeCompliance : { // 5
                label : "Registered Office Compliance",
                link : "https://legislation.nsw.gov.au/view/whole/html/inforce/current/act-2002-066#sec.29",
                type  : "checkbox"
            }
        }
    },
    TypeD : {
        weightage:5,
        formTitle : "Licensee in charge check",
        formDescription : ["Licensee in charge check."],
        fields : {
            licenseinchargeThumbnail : { //6
                label : "Upload Thumbnail for Licensees in Charge's personal license",
                type : "file",
            },
            licenseinchargeExpiry : { //6
                label : "Expiry Date of Licensees in Charge's Personal License",
                type : "date",
            }
        }
    },
    TypeE : {
        weightage:5,
        formTitle : "Professional Indemnity Insurance check ",
        formDescription : ["Professional Indemnity Insurance"],
        fields : { 
            PIInsuranceThumbnail : {//7
                label : "Upload your P.I. insurance",
                link:"https://www.fairtrading.nsw.gov.au/__data/assets/pdf_file/0010/371872/Professional_indemnity_insurance_information_sheet.pdf",
                type : "file",
            },
            PIInsuranceExpiry : { //7
                label : "Expiry Date of your policy",
                type : "date"
            }
        }
    },
    TypeF : {
        weightage:5,
        formTitle : "Public Liability Insurance check",
        formDescription : ["Public Liability Insurance."],
        fields : {
            PLInsuranceThumbnail : { //8
                label : "Upload Thumbnail to appear of Certificate of Currency of P.L. insurance",
                type : "file",
            },
            PLInsuranceExpiry : { //8
                label : "Expiry Date of P.L. Insurance policy",
                type : "date",
            }
        }
    },
    TypeG : {
        weightage:5,
        formTitle : "Workers compensation insurance check",
        formDescription : ["Workers Compansation Insurance."],
        fields : {
            workerCompensationInsurance : { //9
                label : "Upload Thumbnail to appear of Certificate of Currency of Work Comp insurance",
                type : "file",
                link : "https://www.sira.nsw.gov.au/insurance-coverage/workers-compensation-insurance/how-to-get-workers-compensation-insurance",
            },
            workerCompensationExpiry : { //9
                label : "Expiry Sate of W.C Insurance policy",
                type : "date",
            }
        }
    },
    TypeH : {
        weightage:20,
        formTitle : "Statutory Trust account checks",
        formDescription : [
            "Trust account/s",
            "Last year Annual audit report.",
            "Trust account software password protected.",
            "E-news subscription",
        ],
        link : "https://www.onegov.nsw.gov.au/new/agencies/oft/trustaccount.aspx",
        fields : {
            trustAccount : { //10
                label : "Does the business operate a Trust account or Trust accounts.?",
                type  : "checkbox"
            },
            annualAuditReturnLodged : { //13
                label : "Has the annual audit return been lodged with Fair Trading for the Trust account/s?",
                type  : "checkbox"
            },
            trustAccountPasswordProtected : { //18
                label : "Is the Trust accounting software password protected?",
                type  : "checkbox"
            },
            newsletterSubscription : { // 19
                label : "Has the Licensee in charge subscribed to Fair Tradings E-news letter for the property industry?",
                type  : "checkbox",
                link : "https://www.fairtrading.nsw.gov.au/help-centre/online-tools/enews"
            },
        }
    },
    TypeI : {
        weightage:10,
        formTitle : "Statutory Trust account checks",
        formDescription : [
            "Annual audit return of Sales Trust Account",
            "Annual audit return of Prop Management Trust Account"
        ],
        fields : {
            annualAuditSalesReturn : { //14
                question : "Is the annual audit return been lodged with Fair Trading for the Sales Trust account",
                onYes : "Upload copy of Auditors report for Prop Mang Trust",
                onNo : "Which is audit deadline every year",
                link:"https://legislation.nsw.gov.au/view/whole/html/inforce/current/act-2002-066#sec.111",
                type  : "fileOrDate"
            },
            annualAuditPropertyReturn : { //15
                question : "Is the annual audit return been lodged with Fair Trading for the above P.M Trust account",
                onYes : "Upload copy of Auditors report for Prop Mang Trust",
                onNo : "Which is audit deadline every year",
                link:"https://legislation.nsw.gov.au/view/whole/html/inforce/current/act-2002-066#sec.111",
                type : "fileOrDate",
            }
        }
    },
    TypeJ : {
        weightage:10,
        formTitle : "Trust receipt(s) compliance check",
        formDescription : [
            "Trust receipt compliance for Sales receipt",
            "Trust receipt compliance for Prop Manage receipt"
        ],
        fields : {
            salesTrustCompliance : { //16
                link:"https://legislation.nsw.gov.au/view/html/inforce/current/sl-2003-0490#sec.25",
                question : "Are the Sales Trust receipts compliant with Section 25 of the Act.?",
                onYes : "Upload copy of a sales Trust receipt issued by the agency",
                type  : "optionalFile"
            },
            salesTrustReceipt : { //17
                link:"https://legislation.nsw.gov.au/view/html/inforce/current/sl-2003-0490#sec.25",
                question : "Are the Prop Mang Trust receipts compliant with Section 25 of the Act.?",
                onYes : "Upload copy of a sales Trust receipt issued by the agency",
                type : "optionalFile",
            }
        }
    },
    TypeK : {
        weightage:5,
        formTitle : "Staff website/employment check",
        formDescription : ["Staff portrayed on agents website"],
        fields : {
            halfYearlyReviewStatus : { //20
                label : "Have you reviewed, at least 6 monthly, all staff who are portrayed on your website?",
                link : "https://ablisfiles.business.gov.au/newsouthwales/resource/ap4365b.pdf",
                type  : "checkbox"
            },
            halfYearlyReviewStatusExpiry : { //20
                label : "Date",
                type  : "date"
            }
        }
    },
    TypeL : {
        weightage:10,
        formTitle : "Registration of Trust accounts",
        formDescription : [
            "Sales Trust account: (if operating)",
            "Property Management: (if operating)"
        ],
        fields : {
            salesTrustAccount : { //11
                question : "Has the Sales Trust account been registered with Fair Trading and the Financial instituion and given a UID number?",
                onYes : "Upload Thumbnail of Bank Registration page",
                type : "optionalFile",
                link : "https://www.onegov.nsw.gov.au/new/agencies/oft/trustaccount.aspx",
            },
            propertyManagementTrustAccount : { //12
                question : "Has the Property Management Trust account been registered with Fair Trading and the Financial institution and given a UID number?",
                onYes : "Upload Thumbnail of Bank Registration page",
                type : "optionalFile",
                link : "https://www.onegov.nsw.gov.au/new/agencies/oft/trustaccount.aspx",
            },
        }
    }
}

export default frontDeskFormMap ;